module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781449400217_cop.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_c('span', {
    staticClass: "bigcop"
  }, [_vm._v("At Our Table")]), _vm._v(" copyright © 2010 by Roxie Kelley. Illustrations © 2010 by Shelly Reeves Smith. All rights reserved. Printed in China. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews. For information, write Andrews McMeel Publishing, LLC, an Andrews McMeel Universal company, 1130 Walnut Street, Kansas City, Missouri 64106.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("E-ISBN: 978-1-4494-0021-7"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', [_c('em', [_vm._v("Library of Congress Control Number: 2009938773")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', [_c('em', [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_vm._v("www.andrewsmcmeel.com")])]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("ATTENTION: SCHOOLS AND BUSINESSES")]), _c('br'), _c('em', [_vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales promotional use. For information, please write to: Special Sales Department, Andrews McMeel Publishing, LLC, 1130 Walnut Street, Kansas City, Missouri 64106.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "mailto:specialsales@amuniversal.com"
    }
  }, [_vm._v("specialsales@amuniversal.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover illustration by Shelly Reeves Smith")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54464106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400217_epub_cop_r1.vue
// module id = 66
// module chunks = 0